import { defineMessages } from 'react-intl';

export default defineMessages({
	companyFormCompanyNameError: {
		id: 'teams.company.form.companyNameError',
		defaultMessage: "Your company's name is required",
		description: 'Error when validation fails for the company name field on the company form.',
	},
	companyFormCompanySizeError: {
		id: 'teams.company.form.companySizeError',
		defaultMessage: "Your company's size is required",
		description: 'Error when validation fails for the company size field on the company form.',
	},
	companyFormRoleError: {
		id: 'teams.company.form.roleError',
		defaultMessage: 'Your role at the company is required',
		description: 'Error when validation fails for the role field on the company form.',
	},
	companyFormCompanyNameLabel: {
		id: 'teams.company.form.companyNameLabel',
		defaultMessage: 'Company Name (Required)',
		description: 'Label for the company name field on the company form.',
	},
	companyFormCompanySizePlaceholder: {
		id: 'teams.company.form.companySizePlaceholder',
		defaultMessage: 'Company Size (Required)',
		description: 'Placeholder for the company size field on the company form.',
	},
	companyFormRolePlaceholder: {
		id: 'teams.company.form.rolePlaceholder',
		defaultMessage: 'Your Role (Required)',
		description: 'Placeholder for the role field on the company form.',
	},
	companyFormRoleHumanResources: {
		id: 'teams.company.form.role.humanResources',
		defaultMessage: 'Human Resources',
		description: 'User role option within their company.',
	},
	companyFormRoleHealthWellness: {
		id: 'teams.company.form.role.healthWellness',
		defaultMessage: 'Employee Health & Wellness',
		description: 'User role option within their company.',
	},
	companyFormRoleBenefits: {
		id: 'teams.company.form.role.benefits',
		defaultMessage: 'Employee Benefits',
		description: 'User role option within their company.',
	},
	companyFormRoleExec: {
		id: 'teams.company.form.role.exec',
		defaultMessage: 'Company Executive / Senior Leader',
		description: 'User role option within their company.',
	},
	companyFormRoleBroker: {
		id: 'teams.company.form.role.broker',
		defaultMessage: 'Broker / Consultant',
		description: 'User role option within their company.',
	},
	companyFormRoleOther: {
		id: 'teams.company.form.role.other',
		defaultMessage: 'Other',
		description: 'User role option within their company.',
	},
	companyFormCtaCopy: {
		id: 'teams.company.form.cta.copy',
		defaultMessage: 'Continue',
		description: 'Cta button for company form.',
	},
	infoFormErrorBanner: {
		id: 'teams.info.form.errorBanner',
		defaultMessage: 'There {errorCount} that require your attention',
		description: 'Error banner for the form.',
	},
});
